export default "__VITE_ASSET__DRwOjXzB__"